import { getDepartmentTree } from "@/api/userCenter/company"
import { transTreeToArr } from "@/utils/user"

export default {
  provide() {
    return {
      rootDepartment: this.rootDepartment,
      departmentMap: this.departmentMap,
      departments: this.departments
    }
  },
  data() {
    return {
      rootDepartment: {},
      curRequestCompanyDepartmentId: null
    }
  },
  computed: {
    companyId() {
      return this.$store.getters.userInfo?.companyId
    },
    departmentMap() {
      let map = this._.keyBy(this.departments, "id")
      if (map[this.rootDepartment.id]) {
        map[this.rootDepartment.id].name = "全公司"
      }
      return map
    },
    departments() {
      let departmentTree = Object.keys(this.rootDepartment).length ? [this.rootDepartment] : []
      return transTreeToArr(departmentTree)
    }
  },
  created() {
    this.refreshRootDepartment() // 需要有当前企业
  },
  methods: {
    refreshRootDepartment(companyId = this.companyId) {
      if (!companyId || companyId === this.curRequestCompanyDepartmentId) {
        return
      }
      // 为了防止短时间内进行多次请求,后面发起的请求更早响应导致数据不准确的问题
      this.curRequestCompanyDepartmentId = companyId
      getDepartmentTree({ companyId }).then(departmentTree => {
        if (this.curRequestCompanyDepartmentId === companyId) {
          Object.assign(this.rootDepartment, departmentTree[0])
        }
      })
    }
  }
}
